import debounce from 'lodash/debounce';

const formsMixin = {
  mounted() {
    // Require updateForm to exist
    if (typeof this.updateForm !== 'function') throw new Error('formMixin require `updateForm` to be defined.');
    // Require a rererence to form to exist
    if (!this.$refs.form) throw new Error('formMixin require a reference to `form`.');

    this.$refs.form.$children.forEach((child) => {
      child.$on('el.form.change', debounce(() => this.updateForm(child.prop), 700));
      child.$on('el.form.blur', () => this.updateForm(child.prop));
    });
  },
  beforeDestroy() {
    this.$refs.form.$children.forEach((child) => {
      child.$off('el.form.change');
      child.$off('el.form.blur');
    });
  },
};

export default formsMixin;



// WEBPACK FOOTER //
// ./src/mixins/formsMixin.js